<script lang="ts" setup>
import PriceCard from '~/components/workshop/price-card.vue'
import type {WorkshopPricing} from '~/types/workshop'

const props = defineProps<{
  data: Exclude<WorkshopPricing, undefined | null>
}>()
</script>

<template>
  <Container class="screen-content flex flex-col items-center space-y-6 pb-16 md:pb-16 lg:pb-16 lg:pt-24">
    <span class="text-sm font-bold text-main-600">{{ data.eyebrow }}</span>
    <Heading as="h3" size="large">{{ data.title }}</Heading>
    <Paragraph> {{ data.description }}</Paragraph>
  </Container>

  <Container
    class="mx-auto flex justify-center space-x-12 pb-16 xs:flex-col xs:items-center xs:space-x-0 xs:space-y-12 lg:flex-row lg:items-start lg:space-x-16 lg:space-y-0"
  >
    <div v-for="price in data.priceCards">
      <PriceCard :price="price" />
    </div>
  </Container>
</template>
